import React, { Component } from "react";
import { connect } from "react-firebase";
import { compose, getContext } from "recompose";
import styled from "styled-components";
import PropTypes from "prop-types";
import Snackbar from "material-ui/Snackbar";

import { login, getCurrentEmail } from "./actions";
import TransitionChildren from "../common/TransitionChildren";
import Header from "./Header";
import ListView from "./ListView";
import Login from "./Login";
import Loading from "../common/Loading";

const AppStyles = styled.div`
  background-image: linear-gradient(
    ${props => props.colors[0]},
    ${props => props.colors[1]}
  );

  height: 110%;
  .fade {
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
  }

  .fade.out {
    opacity: 0;
  }
`;

class App extends Component {
  static get contextTypes() {
    return {
      filter: PropTypes.func,
      selector: PropTypes.string,
      colors: PropTypes.array
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      user: null,
      loading: true,
      online: true
    };

    this.autoLogin = this.autoLogin.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
  }

  loginUser(opts) {
    this.setState({ loading: true });

    return login(this.props.usersRef(), this.context.selector)(opts)
      .then(() => {
        this.setState({
          user: opts.email,
          loading: false
        });
      })
      .catch(err => {
        console.log("Bad Login", err);
        this.setState({
          user: null,
          loading: false
        });
      });
  }

  autoLogin(email) {
    this.loginUser({ email });
  }

  updateOnlineStatus(evt) {
    this.setState({
      online: evt.type === "online"
    });
  }

  componentDidMount() {
    if (getCurrentEmail(this.context.selector)) {
      this.autoLogin(getCurrentEmail(this.context.selector));
    } else {
      setTimeout(() => this.setState({ loading: false }), 500);
    }

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  }

  renderApp() {
    const { user, loading } = this.state;

    if (loading) {
      return <Loading key="loading" />;
    }

    if (!user) {
      return <Login key="login" loginUser={this.loginUser} />;
    }

    return (
      <div key="app">
        <ListView filter={this.context.filter} />
      </div>
    );
  }

  render() {
    return (
      <AppStyles colors={this.context.colors}>
        <Header />
        <div className="margin-for-header">
          <TransitionChildren transitionClass="out" className="fade">
            {this.renderApp()}
          </TransitionChildren>
        </div>
        <Snackbar
          open={!this.state.online}
          message="You might be offline."
          contentStyle={{ textAlign: "center" }}
        />
      </AppStyles>
    );
  }
}

const AppContainer = compose(
  connect((props, ref, firebase) => ({
    usersRef: () => ref("/users")
  }))
)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/user/App.js